import { render, staticRenderFns } from "./farmland_yuncu.vue?vue&type=template&id=723e597e&"
import script from "./farmland_yuncu.vue?vue&type=script&lang=js&"
export * from "./farmland_yuncu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports